/**
 * Module dependencies.
 */

import modalEnums from 'enums/modal';
import { closeModal, openModal } from 'reducers/modal/actions';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectOpenModals, makeSelectModal } from 'reducers/modal/selectors';

/**
 * Get modal ID.
 */

const getModalId = (key) => {
  const id = modalEnums[key];

  if (!id) {
    throw new Error(`🚨 Modal '${key}' key not found in modal enums!`);
  }

  return id;
};

/**
 * Map state to props.
 */

const mapStateToProps = createStructuredSelector({
  isModalOpen:
    (...args) =>
    (key) =>
      Object.keys(makeSelectOpenModals()(...args).toJS()).includes(getModalId(key)),
  modalState:
    (...args) =>
    (key) =>
      makeSelectModal(key)(...args),
});

/**
 * Map dispatch to props.
 */

const mapDispatchToProps = (dispatch) => ({
  closeModal: (key) => dispatch(closeModal(getModalId(key))),
  openModal: (key, modalProps) => dispatch(openModal(getModalId(key), modalProps)),
});

export default connect(mapStateToProps, mapDispatchToProps);
